export function generateUUID() {
    // 生成当前时间戳的十六进制字符串
    const timestamp = (new Date()).getTime().toString(16);

    // 生成随机数的十六进制字符串
    const randomPart = (Math.random() * 100000000000000000).toString(16);

    // 拼接时间戳和随机数，并添加连字符
    const uuid = timestamp + '-' + randomPart;

    return uuid;
}